module.exports = __webpack_public_path__ + "img/amex.8c977dfd.svg";